<template>

  <section class="dp-layout">
    <section class="dp-left">
      <div class="dept-scope-bar">
        <button
          type="button"
          class="dept-scope-btn"
          :class="{ 'is-active': deptDirectoryScope === 'teaching' }"
          @click="setDeptDirectoryScope('teaching')">
          家校通讯录
        </button>
        <button
          type="button"
          class="dept-scope-btn"
          :class="{ 'is-active': deptDirectoryScope === 'internal' }"
          @click="setDeptDirectoryScope('internal')">
          内部通讯录
        </button>
      </div>
      <DepartmentPane
        :key="deptDirectoryScope"
        :directory-scope="deptDirectoryScope"
        :pane-title="deptDirectoryScope === 'internal' ? '内部通讯录' : '家校通讯录'"
        :default-select-root="true"
        @tree-node-click="treeNodeClick">
      </DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
      <!-- @select="dialogCheck" -->
      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange"
        @row-click="selectCurrentRow" ref="table" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="UserId" label="用户ID" width>
        </el-table-column>

        <el-table-column prop="UserName" label="用户名称" width>
        </el-table-column>
        <el-table-column label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.PersonType === 'teacher'"
              size="mini"
              type="warning"
              effect="plain"
              disable-transitions>
              教职工
            </el-tag>
            <el-tag
              v-else-if="scope.row.PersonType === 'student'"
              size="mini"
              effect="plain"
              disable-transitions>
              学生
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="DiscountActivityName" label="补贴名称" width>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>

        <el-table-column label="星期" min-width="132" align="center">
          <template slot-scope="scope">
            <div class="week-chip-row" v-if="formatWeekChips(scope.row).length">
              <span
                v-for="chip in formatWeekChips(scope.row)"
                :key="chip"
                class="week-chip">{{ chip }}</span>
            </div>
            <span v-else class="week-chip-empty">-</span>
          </template>
        </el-table-column>

        <el-table-column prop="DinnerTimeStrs" label="就餐时间段" header-align="center" align="center" width="200px">

          <template slot-scope="scope">
            <div v-for="s in scope.row.DinnerTimeStrs" :key="s">
              {{ s }}
            </div>
          </template>

        </el-table-column>

        <el-table-column prop="UsedCount" label="已使用次数" width>
        </el-table-column>

        <el-table-column prop="UsedAmount" label="已抵扣金额" width>
        </el-table-column>

        <el-table-column prop="DiscountMode" label="折扣模式" width :formatter="formatDiscountMode">
        </el-table-column>
        <!-- <el-table-column prop="FullAmount" label="满减金额" width>
        </el-table-column> -->
        <el-table-column prop="DiscountAmount" label="折扣金额" width>
        </el-table-column>
        <!-- <el-table-column prop="DiscountRatio" label="折扣比例" width>
        </el-table-column>
        <el-table-column prop="MaxDiscountLimit" label="最大折扣限额" width>
        </el-table-column> -->
        <el-table-column prop="ValidPeriodStartTime" label="开始时间" width>
        </el-table-column>
        <el-table-column prop="ValidPeriodEndTime" label="结束时间" width>
        </el-table-column>
        <el-table-column prop="DiscountPriorityLevel" label="优先级" width>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑用户补贴信息" :visible.sync="editFormVisible" v-model="editFormVisible"
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">

          <el-form-item label="优惠补贴" prop="DiscountSubsidyId">
            <el-select v-model="editForm.DiscountSubsidyId" placeholder="请选择优惠补贴">
              <el-option v-for="item in discountSubsidyList" :key="item.Id" :label="item.DiscountActivityName"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="周期" prop="Weeks">
            <el-checkbox-group v-model="editForm.Weeks">
              <el-checkbox v-for="week in WeeksList" :label="week" :key="week">{{ week }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="就餐时间段" prop="DinnerTimes">
            <el-select v-model="editForm.DinnerTimes" placeholder="请选择就餐时间段" multiple style="width: 100%">
              <el-option v-for="item in dinnerTimeList" :key="item.Id"
                :label="item.DinnerName + '【' + item.StartTime + '-' + item.EndTime + '】'" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 
          <el-form-item label="对象">
            <el-radio-group v-model="useType" v-removeAriaHidden>
              <el-radio class="radio" label="0">人员类型</el-radio>
              <el-radio class="radio" label="1">指定人群</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="人员类型" prop="LiveTypeId">
            <el-select v-model="liveTypeId" placeholder="请选择人员类型">
              <el-option v-for="item in liveTypeList" :key="item.LiveTypeId" :label="item.LiveTypeName"
                :value="item.LiveTypeId"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remarks"></el-input>
          </el-form-item> -->

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增用户补贴信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">



          <el-form-item label="优惠补贴" prop="DiscountSubsidyId">
            <el-select v-model="addForm.DiscountSubsidyId" placeholder="请选择优惠补贴">
              <el-option v-for="item in discountSubsidyList" :key="item.Id" :label="item.DiscountActivityName"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="周期" prop="Weeks">
            <el-checkbox-group v-model="addForm.Weeks">
              <el-checkbox v-for="week in WeeksList" :label="week" :key="week">{{ week }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="就餐时间段" prop="DinnerTimes">
            <el-select v-model="addForm.DinnerTimes" placeholder="请选择就餐时间段" multiple style="width: 100%">
              <el-option v-for="item in dinnerTimeList" :key="item.Id"
                :label="item.DinnerName + '【' + item.StartTime + '-' + item.EndTime + '】'" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 
          <el-form-item label="对象">
            <el-radio-group v-model="useType" v-removeAriaHidden>
              <el-radio class="radio" label="0">人员类型</el-radio>
              <el-radio class="radio" label="1">指定人群</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="人员类型" prop="LiveTypeId">
            <el-select v-model="liveTypeId" placeholder="请选择人员类型">
              <el-option v-for="item in liveTypeList" :key="item.LiveTypeId" :label="item.LiveTypeName"
                :value="item.LiveTypeId"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="人员" required>
            <div class="ps-pick-summary">
              <span>已选 <strong>{{ personScopeCheckedCount }}</strong> 人
                <template v-if="personScopeDeptCount">（{{ personScopeDeptCount }} 个部门）</template>
              </span>
              <el-button type="primary" size="small" plain @click="openPersonScopeDialog">选择人员</el-button>
              <el-button
                v-if="personScopeCheckedCount"
                type="text"
                size="small"
                @click="clearPersonScopeSelection">
                清空
              </el-button>
            </div>
            <div v-if="personScopeCheckedCount" class="ps-pick-tags">
              <el-tag
                v-for="item in personScopeSelectedPreview"
                :key="item.value"
                size="mini"
                closable
                disable-transitions
                @close="removePersonScopeSelected(item.value)">
                {{ item.label }}
              </el-tag>
              <span v-if="personScopeCheckedCount > 8" class="ps-pick-more">等 {{ personScopeCheckedCount }} 人</span>
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 选人：家校/内部通讯录 + 右侧人员表。最后更新：2026-09-15 -->
      <el-dialog
        title="选择人员"
        :visible.sync="personScopeVisible"
        :close-on-click-modal="false"
        append-to-body
        destroy-on-close
        width="1100px"
        top="6vh"
        custom-class="person-scope-dialog"
        @close="onPersonScopeDialogClose">
        <div class="ps-layout" v-loading="personScopeTreeLoading">
          <div class="ps-left">
            <div class="ps-left-header">
              <i class="el-icon-office-building"></i>
              <span>选择机构 / 学校</span>
            </div>
            <div class="ps-scope-bar">
              <button
                type="button"
                class="ps-scope-btn"
                :class="{ 'is-active': personScopeDirectoryScope === 'teaching' }"
                @click="setPersonScopeDirectory('teaching')">
                <i class="el-icon-reading"></i> 家校通讯录
              </button>
              <button
                type="button"
                class="ps-scope-btn"
                :class="{ 'is-active': personScopeDirectoryScope === 'internal' }"
                @click="setPersonScopeDirectory('internal')">
                <i class="el-icon-office-building"></i> 内部通讯录
              </button>
            </div>
            <div class="ps-left-search">
              <el-input
                v-model="personScopeDeptFilter"
                clearable
                size="small"
                prefix-icon="el-icon-search"
                placeholder="输入关键字搜索机构/学校..." />
            </div>
            <div class="ps-left-tree">
              <el-tree
                v-show="personScopeDirectoryScope === 'teaching'"
                ref="personScopeTeachingTree"
                :data="personScopeTeachingTree"
                node-key="value"
                highlight-current
                :expand-on-click-node="false"
                :props="personScopeTreeProps"
                :filter-node-method="filterPersonScopeDeptNode"
                :default-expanded-keys="personScopeTeachingExpandedKeys"
                @node-click="onPersonScopeDeptClick">
                <span class="ps-tree-node" slot-scope="{ node, data }">
                  <span class="ps-tree-node__dot" :class="'tone-' + personScopeNodeTone(data)"></span>
                  <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <el-tree
                v-show="personScopeDirectoryScope === 'internal'"
                ref="personScopeInternalTree"
                :data="personScopeInternalTree"
                node-key="value"
                highlight-current
                :expand-on-click-node="false"
                :props="personScopeTreeProps"
                :filter-node-method="filterPersonScopeDeptNode"
                :default-expanded-keys="personScopeInternalExpandedKeys"
                @node-click="onPersonScopeDeptClick">
                <span class="ps-tree-node" slot-scope="{ node, data }">
                  <span class="ps-tree-node__dot" :class="'tone-' + personScopeNodeTone(data)"></span>
                  <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <div v-if="!personScopeTreeLoading && personScopeCurrentTreeEmpty" class="ps-empty">暂无部门</div>
            </div>
          </div>

          <div class="ps-right">
            <div class="ps-meta">
              已选人员：<strong>{{ personScopeCheckedCount }}</strong> 人
              <span class="ps-meta-sep">·</span>
              涉及部门：<strong>{{ personScopeDeptCount }}</strong> 个
            </div>

            <div class="ps-filter-bar">
              <el-input
                v-model="personScopeNameFilter"
                clearable
                size="small"
                prefix-icon="el-icon-search"
                placeholder="姓名"
                class="ps-name-input"
                @keyup.enter.native="loadPersonScopePeople" />
              <el-button type="primary" size="small" :disabled="!personScopeActiveDeptId" @click="loadPersonScopePeople">
                查询
              </el-button>
              <el-button size="small" :disabled="!personScopeActiveDeptId || !personScopeTableRows.length" @click="selectAllPersonScopeCurrentDept">
                全选当前部门
              </el-button>
              <el-button size="small" :disabled="!personScopeActiveDeptId" @click="clearPersonScopeCurrentDept">
                清空当前部门
              </el-button>
              <el-button size="small" type="text" :disabled="personScopeCheckedCount === 0" @click="clearPersonScopeSelection">
                清空全部已选
              </el-button>
            </div>

            <div class="ps-hint" v-if="personScopeActiveDeptId">
              当前部门：<strong>{{ personScopeActiveDeptName }}</strong>
              <span class="ps-hint-sub">（{{ personScopeDirectoryScope === 'teaching' ? '家校' : '内部' }} · {{ personScopeTableRows.length }} 人）</span>
            </div>
            <div class="ps-hint ps-hint--warn" v-else>请先在左侧选择部门</div>

            <div class="ps-table-wrap" ref="personScopeTableWrap" v-loading="personScopeTableLoading">
              <el-table
                ref="personScopeTable"
                :data="personScopePagedRows"
                row-key="value"
                size="small"
                stripe
                highlight-current-row
                :height="personScopeTableHeight"
                @row-click="onPersonScopeRowClick"
                @selection-change="onPersonScopeTableSelectionChange">
                <el-table-column type="selection" width="46" align="center" />
                <el-table-column prop="label" label="姓名" min-width="120" show-overflow-tooltip />
                <el-table-column label="类型" width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.personType === 'teacher' ? 'warning' : ''" effect="plain" disable-transitions>
                      {{ scope.row.personType === 'teacher' ? '教职工' : '学生' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="deptLabel" label="部门" min-width="140" show-overflow-tooltip />
                <el-table-column label="头像" width="72" align="center" header-align="center">
                  <template slot-scope="scope">
                    <oss-media-thumbs
                      v-if="scope.row.HeadPhotoImage"
                      :media="scope.row.HeadPhotoImage"
                      thumb-width="40px"
                      thumb-height="40px"
                    />
                    <span v-else class="ps-avatar-empty">无</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="ps-pager-wrap">
              <el-pagination
                layout="total, prev, pager, next, jumper"
                :page-size="personScopePageSize"
                :total="personScopeTableRows.length"
                :current-page="personScopePage"
                @current-change="handlePersonScopePageChange" />
            </div>

            <div class="ps-actions">
              <el-button @click="personScopeVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmPersonScopeSelection">
                确定（{{ personScopeCheckedCount }}）
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 名册对比：上传 Excel 仅标记差异，不自动增删。最后更新：2026-09-16 -->
      <el-dialog
        :visible.sync="rosterCompareVisible"
        :close-on-click-modal="false"
        append-to-body
        width="1100px"
        top="2vh"
        custom-class="roster-compare-dialog"
        @close="onRosterCompareClose">
        <div slot="title" class="rc-dialog-title">
          <span class="rc-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div class="rc-dialog-title__text">
            <strong>{{ rosterComparePersonType === 'student' ? '学生名册对比' : '教职工名册对比' }}</strong>
            <em>按顶栏学校比对当前类型人员，仅标记差异，不会自动增删</em>
          </div>
        </div>

        <div class="rc-dialog-body">
          <div class="rc-type-bar">
            <span class="rc-type-bar__label">对比类型</span>
            <el-radio-group v-model="rosterComparePersonType" size="small" @change="onRosterPersonTypeChange">
              <el-radio-button label="teacher">教职工</el-radio-button>
              <el-radio-button label="student">学生</el-radio-button>
            </el-radio-group>
            <span class="rc-type-bar__tip">仅对比该类型补贴用户，避免互相误标待删除</span>
          </div>
          <div class="rc-rules">
            <div class="rc-rule rc-rule--add">
              <span class="rc-rule__badge">待新增</span>
              <p>Excel 有，系统没有</p>
            </div>
            <div class="rc-rule rc-rule--del">
              <span class="rc-rule__badge">待删除</span>
              <p>系统有，Excel 没有</p>
            </div>
            <div class="rc-rule rc-rule--keep">
              <span class="rc-rule__badge">保留</span>
              <p>两边都有，无需处理</p>
            </div>
          </div>
          <p class="rc-rules-note">
            <i class="el-icon-warning-outline"></i>
            勾选后人工处理；Excel 版式不限，能解析出姓名即可
          </p>

          <div v-if="rosterCompareResult" class="rc-result-panel">
            <div class="rc-result-head">
              <div class="rc-stat-cards">
                <div class="rc-stat">
                  <span class="rc-stat__label">学校</span>
                  <strong class="rc-stat__value">{{ rosterCompareResult.SchoolName || '-' }}</strong>
                </div>
                <div class="rc-stat">
                  <span class="rc-stat__label">解析姓名</span>
                  <strong class="rc-stat__value">{{ rosterCompareResult.ExcelNameCount || 0 }}</strong>
                </div>
                <div class="rc-stat rc-stat--add">
                  <span class="rc-stat__label">待新增</span>
                  <strong class="rc-stat__value">{{ rosterAddCount }}</strong>
                </div>
                <div class="rc-stat rc-stat--del">
                  <span class="rc-stat__label">待删除</span>
                  <strong class="rc-stat__value">{{ rosterRemoveCount }}</strong>
                </div>
                <div class="rc-stat rc-stat--keep">
                  <span class="rc-stat__label">保留</span>
                  <strong class="rc-stat__value">{{ rosterKeepCount }}</strong>
                </div>
              </div>
              <div class="rc-result-actions">
                <span class="rc-file" v-if="rosterFileName" :title="rosterFileName">
                  <i class="el-icon-paperclip"></i> {{ rosterFileName }}
                </span>
                <el-upload
                  action=""
                  :auto-upload="false"
                  :show-file-list="false"
                  accept=".xlsx,.xls"
                  :on-change="onRosterFileChange">
                  <el-button size="small" icon="el-icon-refresh" :loading="rosterCompareLoading">重新上传</el-button>
                </el-upload>
              </div>
            </div>

            <div class="rc-toolbar">
              <el-tabs v-model="rosterCompareTab" class="rc-tabs" @tab-click="onRosterCompareTabChange">
                <el-tab-pane :label="'全部 (' + rosterAllCount + ')'" name="all" />
                <el-tab-pane :label="'待新增 (' + rosterAddCount + ')'" name="add" />
                <el-tab-pane :label="'待删除 (' + rosterRemoveCount + ')'" name="remove" />
                <el-tab-pane :label="'保留 (' + rosterKeepCount + ')'" name="keep" />
              </el-tabs>
              <div class="rc-toolbar-right">
                <el-input
                  v-model="rosterSearchKeyword"
                  clearable
                  size="small"
                  prefix-icon="el-icon-search"
                  placeholder="搜索姓名 / 部门 / 补贴"
                  class="rc-search"
                  @input="onRosterSearchInput" />
                <el-button
                  type="warning"
                  size="small"
                  icon="el-icon-download"
                  :disabled="!rosterCompareFilteredRows.length"
                  @click="exportRosterCompareExcel">
                  导出
                </el-button>
              </div>
            </div>

            <div class="rc-actions" v-if="rosterCompareTab === 'add' || rosterCompareTab === 'all' || rosterCompareTab === 'remove'">
              <el-button
                v-if="rosterCompareTab === 'add' || rosterCompareTab === 'all'"
                type="success"
                size="small"
                :disabled="!rosterAddSelection.length"
                @click="openRosterBatchConfig">
                批量配置补贴（{{ rosterAddSelection.length }}）
              </el-button>
              <el-button
                v-if="rosterCompareTab === 'remove' || rosterCompareTab === 'all'"
                type="danger"
                size="small"
                :disabled="!rosterRemoveSelection.length"
                :loading="rosterRemoveLoading"
                @click="batchRemoveRosterUsers">
                批量删除勾选（{{ rosterRemoveSelection.length }}）
              </el-button>
              <span class="rc-actions-tip" v-if="rosterCompareTab === 'add' || rosterCompareTab === 'all'">
                仅可勾选「已匹配」待新增人员；重名/未找到请用页面「新增」手工处理
              </span>
              <span class="rc-actions-tip" v-else>仅删除勾选的补贴用户记录，需二次确认</span>
            </div>

            <div class="rc-table-wrap">
              <el-table
                ref="rosterCompareTable"
                :data="rosterComparePagedRows"
                size="small"
                height="100%"
                border
                class="rc-table"
                @selection-change="onRosterTableSelectionChange">
                <el-table-column
                  v-if="rosterCompareTab !== 'keep'"
                  type="selection"
                  width="46"
                  :selectable="rosterRowSelectable" />
                <el-table-column label="状态" width="88" align="center" v-if="rosterCompareTab === 'all'">
                  <template slot-scope="scope">
                    <el-tag
                      size="mini"
                      :type="rosterStatusTagType(scope.row._status)"
                      effect="plain"
                      disable-transitions>
                      {{ rosterStatusLabel(scope.row._status) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="displayName" label="姓名" min-width="100" show-overflow-tooltip />
                <el-table-column prop="DepartmentName" label="部门" min-width="120" show-overflow-tooltip />
                <el-table-column label="类型" width="90" align="center">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.PersonType === 'teacher'"
                      size="mini"
                      type="warning"
                      effect="plain"
                      disable-transitions>
                      教职工
                    </el-tag>
                    <el-tag
                      v-else-if="scope.row.PersonType === 'student'"
                      size="mini"
                      effect="plain"
                      disable-transitions>
                      学生
                    </el-tag>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="rosterCompareTab === 'add' || rosterCompareTab === 'all'"
                  label="匹配"
                  min-width="180">
                  <template slot-scope="scope">
                    <template v-if="scope.row._status === 'add'">
                      <el-tag v-if="scope.row.Matched" size="mini" type="success">已匹配</el-tag>
                      <el-tag v-else-if="scope.row.Ambiguous" size="mini" type="warning">重名</el-tag>
                      <el-tag v-else size="mini" type="info">未找到</el-tag>
                      <span class="rc-match-tip">{{ scope.row.MatchTip }}</span>
                    </template>
                    <span v-else class="rc-match-tip">{{ scope.row.DiscountActivityName || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="rosterCompareTab === 'remove' || rosterCompareTab === 'keep'"
                  prop="DiscountActivityName"
                  label="补贴名称"
                  min-width="160"
                  show-overflow-tooltip />
                <el-table-column
                  v-if="rosterCompareTab === 'remove' || rosterCompareTab === 'keep'"
                  prop="UserId"
                  label="用户ID"
                  width="100" />
              </el-table>
            </div>

            <div class="rc-pager">
              <el-pagination
                layout="total, sizes, prev, pager, next"
                :page-sizes="[20, 50, 100]"
                :page-size="rosterPageSize"
                :current-page="rosterPage"
                :total="rosterCompareFilteredRows.length"
                @size-change="onRosterPageSizeChange"
                @current-change="onRosterPageChange" />
            </div>
          </div>

          <div v-else class="rc-empty" v-loading="rosterCompareLoading">
            <el-upload
              class="rc-dropzone"
              drag
              action=""
              :auto-upload="false"
              :show-file-list="false"
              accept=".xlsx,.xls"
              :on-change="onRosterFileChange">
              <div class="rc-dropzone__inner">
                <i class="el-icon-upload2 rc-dropzone__icon"></i>
                <h4>上传本学期{{ rosterComparePersonType === 'student' ? '学生' : '教职工' }}名册</h4>
                <p>将文件拖到此处，或 <em>点击选择</em></p>
                <span class="rc-dropzone__fmt">支持 .xlsx / .xls · 版式不限</span>
              </div>
            </el-upload>
          </div>
        </div>
      </el-dialog>

      <!-- 名册对比后批量配置补贴。创建于 2026-09-16 -->
      <el-dialog
        title="批量配置优惠补贴"
        :visible.sync="rosterBatchVisible"
        :close-on-click-modal="false"
        append-to-body
        width="520px">
        <el-form :model="rosterBatchForm" label-width="100px" :rules="addFormRules" ref="rosterBatchForm">
          <el-form-item label="已选人员">
            <span>共 {{ rosterAddSelection.length }} 人</span>
          </el-form-item>
          <el-form-item label="优惠补贴" prop="DiscountSubsidyId">
            <el-select v-model="rosterBatchForm.DiscountSubsidyId" placeholder="请选择优惠补贴" style="width: 100%">
              <el-option
                v-for="item in discountSubsidyList"
                :key="item.Id"
                :label="item.DiscountActivityName"
                :value="item.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="周期" prop="Weeks">
            <el-checkbox-group v-model="rosterBatchForm.Weeks">
              <el-checkbox v-for="week in WeeksList" :label="week" :key="week">{{ week }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="就餐时间段" prop="DinnerTimes">
            <el-select v-model="rosterBatchForm.DinnerTimes" placeholder="请选择就餐时间段" multiple style="width: 100%">
              <el-option
                v-for="item in dinnerTimeList"
                :key="item.Id"
                :label="item.DinnerName + '【' + item.StartTime + '-' + item.EndTime + '】'"
                :value="item.Id" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rosterBatchVisible = false">取消</el-button>
          <el-button type="primary" :loading="rosterBatchLoading" @click="submitRosterBatchConfig">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getDiscountSubsidyUserListPage, getDiscountSubsidyList, getDinnerTimeList, removeDiscountSubsidyUser, editDiscountSubsidyUser, addDiscountSubsidyUser, exportDiscountSubsidyUser, compareDiscountSubsidyRoster } from '../../api/modules/consumption';
import { getTeachingDepartmentTree, getInternalDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getStudentSelectList, getTeacherMasterListPage } from '../../api/modules/personnel';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps'
import {
  lockPersonScopeSelectionSync,
  syncPersonScopeElTableSelection,
} from '../../utils/personScopeTableSelection'
import { utils, writeFile } from 'xlsx'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {},
      BaseApiUrl: BaseApiUrl,
      searchList: [
        { label: '用户名称', key: 'name', width: '140px' },
        {
          label: '优惠补贴',
          key: 'discountSubsidyId',
          type: 'select',
          clearable: true,
          width: '220px',
          placeholder: '全部补贴配置',
          options: [],
        },
      ],
      users: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      deptDirectoryScope: 'teaching',
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        DiscountSubsidyId: [{ required: true, message: '请选择优惠补贴', trigger: 'change' }],
        Weeks: [{ required: true, message: '请选择周期', trigger: 'change' }],
        DinnerTimes: [{ required: true, message: '请选择就餐时间段', trigger: 'change' }],
      },
      editForm: { Id: 0, DiscountSubsidyId: '', Remarks: '', DepartmentId: 0, Weeks: [], DinnerTimes: [] },
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        DiscountSubsidyId: [{ required: true, message: '请选择优惠补贴', trigger: 'change' }],
        Weeks: [{ required: true, message: '请选择周期', trigger: 'change' }],
        DinnerTimes: [{ required: true, message: '请选择就餐时间段', trigger: 'change' }],
      },
      addForm: { DiscountSubsidyId: '', Remarks: '', DepartmentId: 0, Weeks: [], DinnerTimes: [], UserIds: [] },
      DepartmentId: 0,
      discountSubsidyList: [],
      dinnerTimeList: [],
      WeeksList: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      multipleSelection: [],
      personScopeVisible: false,
      personScopeTreeLoading: false,
      personScopeTableLoading: false,
      personScopeDirectoryScope: 'teaching',
      personScopeDeptFilter: '',
      personScopeNameFilter: '',
      personScopeTeachingTree: [],
      personScopeInternalTree: [],
      personScopeTeachingExpandedKeys: [],
      personScopeInternalExpandedKeys: [],
      personScopeTreeProps: { label: 'label', children: 'children' },
      personScopeActiveDeptId: '',
      personScopeActiveDeptName: '',
      personScopeTableRows: [],
      personScopePage: 1,
      personScopePageSize: 10,
      personScopeTableHeight: 400,
      personScopeSelectedMap: {},
      personScopeCheckedCount: 0,
      personScopeDeptCount: 0,
      personScopeSyncingTable: false,
      // 名册对比。创建于 2026-09-16
      rosterCompareVisible: false,
      rosterCompareLoading: false,
      rosterCompareResult: null,
      rosterCompareTab: 'all',
      rosterComparePersonType: 'teacher',
      rosterFileName: '',
      rosterSearchKeyword: '',
      rosterPage: 1,
      rosterPageSize: 20,
      rosterAddSelection: [],
      rosterRemoveSelection: [],
      rosterRemoveLoading: false,
      rosterSyncingSelection: false,
      rosterBatchVisible: false,
      rosterBatchLoading: false,
      rosterBatchForm: { DiscountSubsidyId: '', Weeks: [], DinnerTimes: [] },
    };
  },
  computed: {
    personScopeCurrentTreeEmpty() {
      const tree = this.personScopeDirectoryScope === 'internal'
        ? this.personScopeInternalTree
        : this.personScopeTeachingTree;
      return !tree || !tree.length;
    },
    personScopePagedRows() {
      const rows = this.personScopeTableRows || [];
      const size = this.personScopePageSize || 10;
      const page = this.personScopePage || 1;
      return rows.slice((page - 1) * size, page * size);
    },
    personScopeSelectedPreview() {
      return Object.keys(this.personScopeSelectedMap || {})
        .map((k) => this.personScopeSelectedMap[k])
        .slice(0, 8);
    },
    rosterAddCount() {
      return ((this.rosterCompareResult && this.rosterCompareResult.ToAdd) || []).length;
    },
    rosterRemoveCount() {
      return ((this.rosterCompareResult && this.rosterCompareResult.ToRemove) || []).length;
    },
    rosterKeepCount() {
      return ((this.rosterCompareResult && this.rosterCompareResult.ToKeep) || []).length;
    },
    rosterAllCount() {
      return this.rosterAddCount + this.rosterRemoveCount + this.rosterKeepCount;
    },
    /** 名册对比统一行（含状态）。创建于 2026-09-16 */
    rosterCompareUnifiedRows() {
      const result = this.rosterCompareResult;
      if (!result) return [];
      const rows = [];
      (result.ToAdd || []).forEach((item, idx) => {
        rows.push(Object.assign({}, item, {
          _key: `add-${idx}-${item.Name || ''}`,
          _status: 'add',
          displayName: item.Name || '',
          _raw: item,
        }));
      });
      (result.ToRemove || []).forEach((item, idx) => {
        rows.push(Object.assign({}, item, {
          _key: `remove-${item.Id || idx}`,
          _status: 'remove',
          displayName: item.UserName || '',
          _raw: item,
        }));
      });
      (result.ToKeep || []).forEach((item, idx) => {
        rows.push(Object.assign({}, item, {
          _key: `keep-${item.Id || idx}`,
          _status: 'keep',
          displayName: item.UserName || '',
          _raw: item,
        }));
      });
      return rows;
    },
    rosterCompareSourceRows() {
      const tab = this.rosterCompareTab;
      const all = this.rosterCompareUnifiedRows;
      if (tab === 'add') return all.filter((r) => r._status === 'add');
      if (tab === 'remove') return all.filter((r) => r._status === 'remove');
      if (tab === 'keep') return all.filter((r) => r._status === 'keep');
      return all;
    },
    rosterCompareFilteredRows() {
      const keyword = (this.rosterSearchKeyword || '').trim().toLowerCase();
      const rows = this.rosterCompareSourceRows || [];
      if (!keyword) return rows;
      return rows.filter((row) => {
        const parts = [
          row.displayName,
          row.DepartmentName,
          row.DiscountActivityName,
          row.MatchTip,
          row.UserId,
        ];
        return parts.some((p) => String(p || '').toLowerCase().indexOf(keyword) !== -1);
      });
    },
    rosterComparePagedRows() {
      const rows = this.rosterCompareFilteredRows || [];
      const size = this.rosterPageSize || 20;
      const page = this.rosterPage || 1;
      return rows.slice((page - 1) * size, page * size);
    },
  },
  watch: {
    personScopeDeptFilter(val) {
      const tree = this.personScopeDirectoryScope === 'internal'
        ? this.$refs.personScopeInternalTree
        : this.$refs.personScopeTeachingTree;
      if (tree) tree.filter(val);
    }
  },
  beforeDestroy() {
    this.unbindPersonScopeResize();
    clearTimeout(this._treeClickDedupeTimer);
  },
  methods: {
    formatDiscountMode(row) {
      if (row.DiscountMode == '1') return '固定金额';
      if (row.DiscountMode == '2') return '比例金额';
      return '';
    },
    /** 星期紧凑展示：一~日。创建于 2026-09-16 */
    formatWeekChips(row) {
      const shortMap = {
        星期一: '一',
        星期二: '二',
        星期三: '三',
        星期四: '四',
        星期五: '五',
        星期六: '六',
        星期日: '日',
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六',
        '7': '日',
      };
      let raw = [];
      if (row && Array.isArray(row.Weeks) && row.Weeks.length) {
        raw = row.Weeks;
      } else if (row && row.Week) {
        raw = String(row.Week).split(/[,，]/);
      }
      const set = {};
      raw.forEach((item) => {
        const key = String(item || '').trim();
        if (!key) return;
        const short = shortMap[key] || shortMap[key.replace(/^周/, '星期')] || '';
        if (short) set[short] = true;
      });
      return ['一', '二', '三', '四', '五', '六', '日'].filter((d) => set[d]);
    },
    treeNodeClick(data) {
      const nextId = data && (data.value != null ? data.value : data.Id);
      // 部门树进页默认选中会连发两次，同范围同节点短时去重。最后更新：2026-09-16
      const dedupeKey = `${this.deptDirectoryScope}|${nextId}`;
      if (dedupeKey === this._treeClickDedupeKey) return;
      this._treeClickDedupeKey = dedupeKey;
      clearTimeout(this._treeClickDedupeTimer);
      this._treeClickDedupeTimer = setTimeout(() => {
        this._treeClickDedupeKey = '';
      }, 400);

      this.DepartmentId = nextId;
      this.page = 1;
      this.loadSubsidyFilterOptions();
      this.handleQuery();
    },
    /** 切换家校 / 内部通讯录树。创建于 2026-09-16 */
    setDeptDirectoryScope(scope) {
      if (scope !== 'teaching' && scope !== 'internal') return;
      if (this.deptDirectoryScope === scope) return;
      this.deptDirectoryScope = scope;
      this.DepartmentId = 0;
      this.users = [];
      this.total = 0;
      this._treeClickDedupeKey = '';
      this.clearSubsidyFilterOptions();
    },
    /** 加载优惠补贴筛选下拉。创建于 2026-09-16 */
    loadSubsidyFilterOptions() {
      const departmentId = this.DepartmentId || resolveActiveSchoolId(this) || 0;
      const item = (this.searchList || []).find((s) => s.key === 'discountSubsidyId');
      if (!item) return;
      if (!departmentId) {
        item.options = [];
        return;
      }
      getDiscountSubsidyList({ departmentId }).then((res) => {
        const list = (res.data && res.data.response) || [];
        item.options = list.map((x) => ({
          label: x.DiscountActivityName,
          value: x.Id,
        }));
      }).catch(() => {
        item.options = [];
      });
    },
    clearSubsidyFilterOptions() {
      const item = (this.searchList || []).find((s) => s.key === 'discountSubsidyId');
      if (item) item.options = [];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectCurrentRow(val) {
      if (!val) return;
      this.currentRow = val;
      this.$refs.table.clearSelection();
      this.$refs.table.toggleRowSelection(val, true);
    },
    callFunction(item) {
      if (typeof item.search == 'object') this.filters = item.search;
      else this.filters = { key: item.search };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleQuery() {
      this.listLoading = true;
      testapi();
      getDiscountSubsidyUserListPage({
        page: this.page,
        departmentId: this.DepartmentId,
        directoryScope: this.deptDirectoryScope,
        ...this.filters,
      }).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    handleDel() {
      if (!this.multipleSelection.length) {
        this.$message({ message: '请选择要删除的数据！', type: 'error' });
        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', { type: 'warning' }).then(() => {
        this.listLoading = true;
        const ids = this.multipleSelection.map((item) => item.Id).join(',');
        removeDiscountSubsidyUser({ ids }).then((res) => {
          this.listLoading = false;
          if (util.isEmt.format(res)) return;
          this.$message({
            message: res.data.success ? '删除成功' : res.data.msg,
            type: res.data.success ? 'success' : 'error',
          });
          this.handleQuery();
        });
      }).catch(() => { });
    },
    handleEdit() {
      const rows = this.multipleSelection;
      if (rows.length !== 1) {
        this.$message({ message: '请选择一行数据进行编辑！', type: 'error' });
        return;
      }
      const row = rows[0];
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      const paraItem = { departmentId: row.ParentDepartmentId };
      getDiscountSubsidyList(paraItem).then((res) => {
        this.discountSubsidyList = res.data.response;
      });
      getDinnerTimeList(paraItem).then((res) => {
        this.dinnerTimeList = res.data.response;
      });
    },
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({ message: '请先选择左侧所属机构！', type: 'warning' });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        DiscountSubsidyId: '',
        Remarks: '',
        DepartmentId: this.DepartmentId,
        Weeks: [],
        DinnerTimes: [],
        UserIds: [],
      };
      this.clearPersonScopeSelection();
      const para = { departmentId: this.DepartmentId };
      getDiscountSubsidyList(para).then((res) => {
        this.discountSubsidyList = res.data.response;
      });
      getDinnerTimeList(para).then((res) => {
        this.dinnerTimeList = res.data.response;
      });
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          this.editLoading = true;
          editDiscountSubsidyUser(Object.assign({}, this.editForm)).then((res) => {
            this.editLoading = false;
            if (util.isEmt.format(res)) return;
            if (res.data.success) {
              this.$message({ message: res.data.msg, type: 'success' });
              this.$refs.editForm.resetFields();
              this.editFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({ message: res.data.msg, type: 'error' });
            }
          });
        });
      });
    },
    addSubmit() {
      if (!this.personScopeCheckedCount) {
        this.$message({ message: '请先选择人员', type: 'warning' });
        return;
      }
      this.addForm.UserIds = this.collectPersonScopeUserIds();
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          this.addLoading = true;
          addDiscountSubsidyUser(Object.assign({}, this.addForm)).then((res) => {
            this.addLoading = false;
            if (util.isEmt.format(res)) return;
            if (res.data.success) {
              this.$message({ message: res.data.msg, type: 'success' });
              this.$refs.addForm.resetFields();
              this.clearPersonScopeSelection();
              this.addFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({ message: res.data.msg, type: 'error' });
            }
          });
        });
      });
    },
    async exportExcel() {
      try {
        const response = await exportDiscountSubsidyUser({
          page: this.page,
          departmentId: this.DepartmentId,
          directoryScope: this.deptDirectoryScope,
          ...this.filters,
        });
        if (!response.data) {
          this.$message({ message: '导出数据为空', type: 'error' });
          return;
        }
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '优惠补贴用户报表.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

    /** 打开选人弹窗。最后更新：2026-09-15 */
    openPersonScopeDialog() {
      this.personScopeDirectoryScope = 'teaching';
      this.personScopeDeptFilter = '';
      this.personScopeNameFilter = '';
      this.personScopeActiveDeptId = '';
      this.personScopeActiveDeptName = '';
      this.personScopeTableRows = [];
      this.personScopePage = 1;
      this.personScopeVisible = true;
      this.loadPersonScopeDirectoryTrees();
      this.$nextTick(() => this.syncPersonScopeTableHeight());
    },
    onPersonScopeDialogClose() {
      this.unbindPersonScopeResize();
      this.personScopeDeptFilter = '';
      this.personScopeNameFilter = '';
      this.personScopeActiveDeptId = '';
      this.personScopeActiveDeptName = '';
      this.personScopeTableRows = [];
      this.personScopePage = 1;
      this.personScopeTableLoading = false;
    },
    confirmPersonScopeSelection() {
      this.addForm.UserIds = this.collectPersonScopeUserIds();
      this.personScopeVisible = false;
    },
    collectPersonScopeUserIds() {
      return Object.keys(this.personScopeSelectedMap || {}).map((k) => {
        const n = this.personScopeSelectedMap[k];
        return [String(n.deptId), String(n.value)];
      });
    },
    removePersonScopeSelected(userId) {
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      delete nextMap[String(userId)];
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.addForm.UserIds = this.collectPersonScopeUserIds();
    },
    normalizePersonScopeTreeRoot(root) {
      if (!root) return [];
      if (Number(root.value || 0) === 0 && root.children && root.children.length) {
        return root.children;
      }
      return [root];
    },
    firstPersonScopeTreeKey(nodes) {
      if (!nodes || !nodes.length) return '';
      return nodes[0] && nodes[0].value != null ? String(nodes[0].value) : '';
    },
    loadPersonScopeDirectoryTrees() {
      this.personScopeTreeLoading = true;
      const scopeId = this.DepartmentId || 0;
      const p1 = getTeachingDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
        .then((res) => {
          this.personScopeTeachingTree = this.normalizePersonScopeTreeRoot(res && res.data && res.data.response);
          const key = this.firstPersonScopeTreeKey(this.personScopeTeachingTree);
          this.personScopeTeachingExpandedKeys = key ? [key] : [];
        })
        .catch(() => { this.personScopeTeachingTree = []; });
      const p2 = getInternalDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
        .then((res) => {
          this.personScopeInternalTree = this.normalizePersonScopeTreeRoot(res && res.data && res.data.response);
          const key = this.firstPersonScopeTreeKey(this.personScopeInternalTree);
          this.personScopeInternalExpandedKeys = key ? [key] : [];
        })
        .catch(() => { this.personScopeInternalTree = []; });
      Promise.all([p1, p2]).finally(() => {
        this.personScopeTreeLoading = false;
        this.$nextTick(() => this.syncPersonScopeTableHeight());
      });
    },
    setPersonScopeDirectory(scope) {
      if (scope !== 'teaching' && scope !== 'internal') return;
      if (this.personScopeDirectoryScope === scope) return;
      this.personScopeDirectoryScope = scope;
      this.personScopeDeptFilter = '';
      this.$nextTick(() => {
        const tree = scope === 'internal'
          ? this.$refs.personScopeInternalTree
          : this.$refs.personScopeTeachingTree;
        if (tree && this.personScopeActiveDeptId) {
          tree.setCurrentKey(this.personScopeActiveDeptId);
        }
      });
    },
    filterPersonScopeDeptNode(value, data) {
      if (!value) return true;
      return (data.label || '').indexOf(value) !== -1;
    },
    personScopeNodeTone(data) {
      if (!data) return 'default';
      const type = (data.DeptOrgType || data.deptOrgType || '').toLowerCase();
      if (type === 'school' || data.IsCompany || data.isCompany) return 'school';
      if (type === 'campus') return 'campus';
      if (type === 'period' || type === 'stage') return 'period';
      if (type === 'grade') return 'grade';
      if (type === 'class') return 'class';
      if (data.BigType === 0 || data.bigType === 0) return 'internal';
      return 'default';
    },
    onPersonScopeDeptClick(data) {
      const id = data && (data.value != null ? data.value : data.Id);
      if (id == null || Number(id) <= 0) {
        this.$message.warning('请选择具体部门');
        return;
      }
      this.personScopeActiveDeptId = String(id);
      this.personScopeActiveDeptName = data.label || data.Name || '';
      this.personScopeNameFilter = '';
      this.personScopePage = 1;
      this.loadPersonScopePeople();
    },
    loadPersonScopePeople() {
      const deptId = this.personScopeActiveDeptId;
      if (!deptId) return;
      this.personScopeTableLoading = true;
      this.personScopePage = 1;
      const name = (this.personScopeNameFilter || '').trim();
      const isTeaching = this.personScopeDirectoryScope === 'teaching';
      const request = isTeaching
        ? getStudentSelectList({ departmentId: deptId, name }).then((res) => {
            const list = (res.data && res.data.response) || [];
            return list.map((s) => ({
              value: String(s.Id),
              label: s.Name || s.StuName || '',
              deptId: String(s.DepartmentId || deptId),
              deptLabel: s.DepartmentName || this.personScopeActiveDeptName,
              scopeDeptId: String(deptId),
              personType: 'student',
              HeadPhotoImage: s.HeadPhotoImage || '',
            }));
          })
        : this.loadAllPersonScopeTeachers(deptId, name);
      request.then((rows) => {
        this.personScopeTableRows = rows || [];
        this.$nextTick(() => {
          this.syncPersonScopeTableHeight();
          this.syncPersonScopeTableSelection();
          this.prefetchPersonScopeAvatars();
        });
      }).catch(() => {
        this.personScopeTableRows = [];
      }).finally(() => {
        this.personScopeTableLoading = false;
      });
    },
    async loadAllPersonScopeTeachers(deptId, name) {
      const pageSize = 500;
      let page = 1;
      let total = 0;
      const all = [];
      do {
        const res = await getTeacherMasterListPage({
          page,
          departmentId: deptId,
          intPageSize: pageSize,
          teacherName: name,
        });
        const pageData = (res.data && res.data.response) || {};
        const list = pageData.data || [];
        total = pageData.dataCount || list.length;
        list.forEach((t) => {
          all.push({
            value: String(t.Id),
            label: t.TeacherName || t.Name || '',
            deptId: String(t.DepartmentId || deptId),
            deptLabel: t.DepartmentName || t.ContextDepartmentName || t.DefaultDepartmentName || this.personScopeActiveDeptName,
            scopeDeptId: String(deptId),
            personType: 'teacher',
            HeadPhotoImage: t.HeadPhotoImage || '',
          });
        });
        if (!list.length || all.length >= total) break;
        page += 1;
      } while (page <= 200);
      return all;
    },
    handlePersonScopePageChange(page) {
      // 先锁住 selection-change，避免翻页时空选清掉当页已选。最后更新：2026-10-29
      lockPersonScopeSelectionSync(this);
      this.personScopePage = page;
      this.$nextTick(() => {
        this.syncPersonScopeTableSelection();
        this.prefetchPersonScopeAvatars();
      });
    },
    prefetchPersonScopeAvatars() {
      const rows = this.personScopePagedRows || [];
      if (!rows.length) return;
      this.prefetchListOssMedia(rows, 'HeadPhotoImage');
    },
    syncPersonScopeTableHeight() {
      const measure = () => {
        const wrap = this.$refs.personScopeTableWrap;
        if (!wrap) return;
        const h = Math.floor(wrap.clientHeight);
        if (h > 120 && h !== this.personScopeTableHeight) {
          this.personScopeTableHeight = h;
          this.$nextTick(() => {
            if (this.$refs.personScopeTable && this.$refs.personScopeTable.doLayout) {
              this.$refs.personScopeTable.doLayout();
            }
          });
        }
      };
      this.$nextTick(() => {
        measure();
        setTimeout(measure, 60);
      });
      this.bindPersonScopeResize();
    },
    bindPersonScopeResize() {
      if (this._personScopeResizeBound) return;
      this._personScopeOnResize = () => this.syncPersonScopeTableHeight();
      window.addEventListener('resize', this._personScopeOnResize);
      this._personScopeResizeBound = true;
    },
    unbindPersonScopeResize() {
      if (this._personScopeOnResize) {
        window.removeEventListener('resize', this._personScopeOnResize);
        this._personScopeOnResize = null;
      }
      this._personScopeResizeBound = false;
    },
    syncPersonScopeTableSelection() {
      syncPersonScopeElTableSelection({
        vm: this,
        tableRef: 'personScopeTable',
        rows: this.personScopePagedRows || [],
        isSelected: (row) => !!this.personScopeSelectedMap[row.value],
      });
    },
    onPersonScopeRowClick(row, column, event) {
      if (event && event.target) {
        const target = event.target;
        if (
          target.classList.contains('el-checkbox__original') ||
          target.classList.contains('el-checkbox__inner') ||
          (target.closest && target.closest('.el-checkbox'))
        ) {
          return;
        }
      }
      const table = this.$refs.personScopeTable;
      if (!table || !row) return;
      table.toggleRowSelection(row);
    },
    onPersonScopeTableSelectionChange(selection) {
      if (this.personScopeSyncingTable) return;
      const selectedIds = {};
      (selection || []).forEach((row) => {
        selectedIds[row.value] = true;
      });
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      (this.personScopePagedRows || []).forEach((row) => {
        if (selectedIds[row.value]) {
          nextMap[row.value] = {
            value: row.value,
            label: row.label,
            deptId: row.deptId,
            deptLabel: row.deptLabel,
            scopeDeptId: row.scopeDeptId,
            personType: row.personType,
          };
        } else {
          delete nextMap[row.value];
        }
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
    },
    selectAllPersonScopeCurrentDept() {
      const people = this.personScopeTableRows || [];
      if (!people.length) return;
      lockPersonScopeSelectionSync(this);
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      people.forEach((row) => {
        nextMap[row.value] = {
          value: row.value,
          label: row.label,
          deptId: row.deptId,
          deptLabel: row.deptLabel,
          scopeDeptId: row.scopeDeptId,
          personType: row.personType,
        };
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },
    clearPersonScopeCurrentDept() {
      lockPersonScopeSelectionSync(this);
      const scopeId = String(this.personScopeActiveDeptId || '');
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      Object.keys(nextMap).forEach((k) => {
        const row = nextMap[k];
        if (String(row.scopeDeptId || row.deptId) === scopeId) delete nextMap[k];
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },
    clearPersonScopeSelection() {
      lockPersonScopeSelectionSync(this);
      this.personScopeSelectedMap = {};
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
      if (this.addForm) this.addForm.UserIds = [];
    },
    refreshPersonScopeSummary() {
      const list = Object.keys(this.personScopeSelectedMap || {}).map((k) => this.personScopeSelectedMap[k]);
      this.personScopeCheckedCount = list.length;
      const deptSet = {};
      list.forEach((n) => {
        if (n && n.deptId != null) deptSet[String(n.deptId)] = true;
      });
      this.personScopeDeptCount = Object.keys(deptSet).length;
    },

    /** 打开名册对比弹窗。创建于 2026-09-16 */
    handleRosterCompare() {
      const schoolId = resolveActiveSchoolId(this) || this.DepartmentId;
      if (!schoolId) {
        this.$message.warning('请先在顶栏选择学校');
        return;
      }
      // 左侧通讯录：家校→学生，内部→教职工
      this.rosterComparePersonType = this.deptDirectoryScope === 'teaching' ? 'student' : 'teacher';
      this.rosterCompareVisible = true;
      this.rosterCompareResult = null;
      this.rosterCompareTab = 'all';
      this.rosterFileName = '';
      this.rosterSearchKeyword = '';
      this.rosterPage = 1;
      this.rosterAddSelection = [];
      this.rosterRemoveSelection = [];
    },
    onRosterCompareClose() {
      this.rosterCompareLoading = false;
      this.rosterAddSelection = [];
      this.rosterRemoveSelection = [];
      this.rosterSearchKeyword = '';
      this.rosterPage = 1;
    },
    /** 切换对比类型后清空结果，需重新上传。创建于 2026-09-16 */
    onRosterPersonTypeChange() {
      if (this._rosterPersonTypeSyncing) return;
      this.rosterCompareResult = null;
      this.rosterFileName = '';
      this.rosterAddSelection = [];
      this.rosterRemoveSelection = [];
      this.rosterSearchKeyword = '';
      this.rosterPage = 1;
    },
    onRosterFileChange(file) {
      const raw = file && file.raw;
      if (!raw) return;
      if (!/\.(xls|xlsx)$/i.test(raw.name || '')) {
        this.$message.error('请上传 .xls 或 .xlsx 文件');
        return;
      }
      this.uploadRosterCompare(raw);
    },
    /** 上传名册并对比（按学校 + 人员类型）。最后更新：2026-09-16 */
    uploadRosterCompare(file) {
      const schoolId = resolveActiveSchoolId(this) || this.DepartmentId;
      if (!schoolId) {
        this.$message.warning('请先在顶栏选择学校');
        return;
      }
      const formData = new FormData();
      formData.append('File', file);
      formData.append('DepartmentId', String(schoolId));
      formData.append('PersonType', this.rosterComparePersonType || 'teacher');
      const subsidyId = this.filters && this.filters.discountSubsidyId;
      if (subsidyId) formData.append('DiscountSubsidyId', String(subsidyId));

      this.rosterCompareLoading = true;
      this.rosterFileName = file.name || '';
      compareDiscountSubsidyRoster(formData).then((res) => {
        this.rosterCompareLoading = false;
        if (util.isEmt.format(res)) return;
        if (!res.data.success) {
          this.$message.error(res.data.msg || '对比失败');
          return;
        }
        const raw = res.data.response || null;
        // 兼容 PascalCase / camelCase。最后更新：2026-09-16
        this.rosterCompareResult = this.normalizeRosterCompareResult(raw);
        const nextType = this.rosterCompareResult && this.rosterCompareResult.PersonType;
        if (nextType && nextType !== this.rosterComparePersonType) {
          this._rosterPersonTypeSyncing = true;
          this.rosterComparePersonType = nextType;
          this.$nextTick(() => { this._rosterPersonTypeSyncing = false; });
        }
        this.rosterCompareTab = 'all';
        this.rosterSearchKeyword = '';
        this.rosterPage = 1;
        this.rosterAddSelection = [];
        this.rosterRemoveSelection = [];
        this.$message.success(res.data.msg || '对比完成');
        this.$nextTick(() => this.syncRosterTableSelection());
      }).catch((err) => {
        this.rosterCompareLoading = false;
        this.$message.error((err && err.message) || '对比失败');
      });
    },
    /** 统一名册对比结果字段大小写。创建于 2026-09-16 */
    normalizeRosterCompareResult(raw) {
      if (!raw) return null;
      const mapAdd = (list) => (list || []).map((item) => ({
        Name: item.Name != null ? item.Name : item.name,
        Matched: item.Matched != null ? item.Matched : item.matched,
        Ambiguous: item.Ambiguous != null ? item.Ambiguous : item.ambiguous,
        UserId: item.UserId != null ? item.UserId : item.userId,
        DepartmentId: item.DepartmentId != null ? item.DepartmentId : item.departmentId,
        DepartmentName: item.DepartmentName != null ? item.DepartmentName : item.departmentName,
        PersonType: item.PersonType != null ? item.PersonType : item.personType,
        MatchTip: item.MatchTip != null ? item.MatchTip : item.matchTip,
      }));
      const mapExist = (list) => (list || []).map((item) => ({
        Id: item.Id != null ? item.Id : item.id,
        UserId: item.UserId != null ? item.UserId : item.userId,
        UserName: item.UserName != null ? item.UserName : item.userName,
        DepartmentName: item.DepartmentName != null ? item.DepartmentName : item.departmentName,
        DiscountSubsidyId: item.DiscountSubsidyId != null ? item.DiscountSubsidyId : item.discountSubsidyId,
        DiscountActivityName: item.DiscountActivityName != null ? item.DiscountActivityName : item.discountActivityName,
        PersonType: item.PersonType != null ? item.PersonType : item.personType,
      }));
      return {
        ExcelNameCount: raw.ExcelNameCount != null ? raw.ExcelNameCount : raw.excelNameCount,
        SchoolDepartmentId: raw.SchoolDepartmentId != null ? raw.SchoolDepartmentId : raw.schoolDepartmentId,
        SchoolName: raw.SchoolName != null ? raw.SchoolName : raw.schoolName,
        PersonType: raw.PersonType != null ? raw.PersonType : raw.personType,
        ToAdd: mapAdd(raw.ToAdd || raw.toAdd),
        ToRemove: mapExist(raw.ToRemove || raw.toRemove),
        ToKeep: mapExist(raw.ToKeep || raw.toKeep),
      };
    },
    rosterStatusLabel(status) {
      if (status === 'add') return '待新增';
      if (status === 'remove') return '待删除';
      if (status === 'keep') return '保留';
      return '-';
    },
    rosterStatusTagType(status) {
      if (status === 'add') return 'success';
      if (status === 'remove') return 'danger';
      if (status === 'keep') return '';
      return 'info';
    },
    rosterRowSelectable(row) {
      if (!row) return false;
      if (row._status === 'add') return !!(row.Matched && row.UserId);
      if (row._status === 'remove') return true;
      return false;
    },
    rosterAddSelectable(row) {
      return this.rosterRowSelectable(row);
    },
    onRosterSearchInput() {
      this.rosterPage = 1;
      this.$nextTick(() => this.syncRosterTableSelection());
    },
    onRosterCompareTabChange() {
      this.rosterPage = 1;
      this.$nextTick(() => this.syncRosterTableSelection());
    },
    onRosterPageChange(page) {
      this.rosterPage = page;
      this.$nextTick(() => this.syncRosterTableSelection());
    },
    onRosterPageSizeChange(size) {
      this.rosterPageSize = size;
      this.rosterPage = 1;
      this.$nextTick(() => this.syncRosterTableSelection());
    },
    /** 导出当前页签（含搜索条件）的名册对比结果。创建于 2026-09-16 */
    exportRosterCompareExcel() {
      const rows = this.rosterCompareFilteredRows || [];
      if (!rows.length) {
        this.$message.warning('暂无数据可导出');
        return;
      }
      const personTypeName = (t) => {
        if (t === 'teacher') return '教职工';
        if (t === 'student') return '学生';
        return '';
      };
      const matchText = (row) => {
        if (row._status !== 'add') return row.DiscountActivityName || '';
        if (row.Matched) return `已匹配 ${row.MatchTip || ''}`.trim();
        if (row.Ambiguous) return `重名 ${row.MatchTip || ''}`.trim();
        return `未找到 ${row.MatchTip || ''}`.trim();
      };
      const exportRows = rows.map((row) => ({
        状态: this.rosterStatusLabel(row._status),
        姓名: row.displayName || '',
        部门: row.DepartmentName || '',
        类型: personTypeName(row.PersonType),
        匹配或补贴: matchText(row),
        用户ID: row.UserId != null ? String(row.UserId) : '',
      }));
      const sheet = utils.json_to_sheet(exportRows);
      const book = utils.book_new();
      const tabNameMap = { all: '全部', add: '待新增', remove: '待删除', keep: '保留' };
      const sheetName = tabNameMap[this.rosterCompareTab] || '名册对比';
      utils.book_append_sheet(book, sheet, sheetName);
      const schoolName = (this.rosterCompareResult && this.rosterCompareResult.SchoolName) || '';
      const fileName = `名册对比_${schoolName || '导出'}_${sheetName}.xlsx`;
      writeFile(book, fileName);
      this.$message.success(`已导出 ${exportRows.length} 条`);
    },
    /** 同步当前页勾选状态（跨页保留选中）。创建于 2026-09-16 */
    syncRosterTableSelection() {
      const table = this.$refs.rosterCompareTable;
      if (!table) return;
      this.rosterSyncingSelection = true;
      table.clearSelection();
      const addMap = {};
      (this.rosterAddSelection || []).forEach((r) => {
        const key = r && r._key ? r._key : `add-${r.Name || ''}`;
        addMap[key] = true;
      });
      const removeMap = {};
      (this.rosterRemoveSelection || []).forEach((r) => {
        const key = r && r._key ? r._key : `remove-${r.Id}`;
        removeMap[String(key)] = true;
      });
      (this.rosterComparePagedRows || []).forEach((row) => {
        if (row._status === 'add' && addMap[row._key]) table.toggleRowSelection(row, true);
        if (row._status === 'remove' && removeMap[row._key]) table.toggleRowSelection(row, true);
      });
      this.$nextTick(() => {
        this.rosterSyncingSelection = false;
      });
    },
    onRosterTableSelectionChange(selection) {
      if (this.rosterSyncingSelection) return;
      const pageRows = this.rosterComparePagedRows || [];
      const selectedKeys = {};
      (selection || []).forEach((row) => {
        if (row && row._key) selectedKeys[row._key] = true;
      });

      // 仅更新当前页对应状态的选中，保留其它页已选
      const pageAddKeys = {};
      const pageRemoveKeys = {};
      pageRows.forEach((row) => {
        if (row._status === 'add') pageAddKeys[row._key] = true;
        if (row._status === 'remove') pageRemoveKeys[row._key] = true;
      });

      const nextAdd = (this.rosterAddSelection || []).filter((r) => {
        const key = r && r._key ? r._key : `add-${r.Name || ''}`;
        return !pageAddKeys[key];
      });
      const nextRemove = (this.rosterRemoveSelection || []).filter((r) => {
        const key = r && r._key ? r._key : `remove-${r.Id}`;
        return !pageRemoveKeys[key];
      });

      (selection || []).forEach((row) => {
        if (row._status === 'add' && selectedKeys[row._key]) nextAdd.push(row._raw || row);
        if (row._status === 'remove' && selectedKeys[row._key]) nextRemove.push(row._raw || row);
      });

      this.rosterAddSelection = nextAdd;
      this.rosterRemoveSelection = nextRemove;
    },
    onRosterAddSelectionChange(val) {
      this.rosterAddSelection = val || [];
    },
    onRosterRemoveSelectionChange(val) {
      this.rosterRemoveSelection = val || [];
    },
    /** 打开待新增人员的批量补贴配置。创建于 2026-09-16 */
    openRosterBatchConfig() {
      const matched = (this.rosterAddSelection || []).filter((r) => r.Matched && r.UserId);
      if (!matched.length) {
        this.$message.warning('请勾选已匹配的人员');
        return;
      }
      const departmentId = resolveActiveSchoolId(this) || this.DepartmentId;
      if (!departmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      this.rosterBatchForm = { DiscountSubsidyId: '', Weeks: [], DinnerTimes: [] };
      this.rosterBatchVisible = true;
      getDiscountSubsidyList({ departmentId }).then((res) => {
        this.discountSubsidyList = (res.data && res.data.response) || [];
      });
      getDinnerTimeList({ departmentId }).then((res) => {
        this.dinnerTimeList = (res.data && res.data.response) || [];
      });
    },
    submitRosterBatchConfig() {
      this.$refs.rosterBatchForm.validate((valid) => {
        if (!valid) return;
        const matched = (this.rosterAddSelection || []).filter((r) => r.Matched && r.UserId);
        if (!matched.length) {
          this.$message.warning('请勾选已匹配的人员');
          return;
        }
        this.$confirm(`确认为 ${matched.length} 人配置优惠补贴吗？`, '提示', {}).then(() => {
          this.rosterBatchLoading = true;
          const payload = {
            DiscountSubsidyId: this.rosterBatchForm.DiscountSubsidyId,
            Weeks: this.rosterBatchForm.Weeks,
            DinnerTimes: this.rosterBatchForm.DinnerTimes,
            UserIds: matched.map((r) => [String(r.DepartmentId || 0), String(r.UserId)]),
          };
          addDiscountSubsidyUser(payload).then((res) => {
            this.rosterBatchLoading = false;
            if (util.isEmt.format(res)) return;
            if (res.data.success) {
              this.$message.success(res.data.msg || '配置成功');
              this.rosterBatchVisible = false;
              this.handleQuery();
              // 重新上传同一文件代价高，直接从待新增列表移除已配置姓名
              const done = {};
              matched.forEach((r) => { done[String(r.Name)] = true; });
              if (this.rosterCompareResult && this.rosterCompareResult.ToAdd) {
                this.rosterCompareResult.ToAdd = this.rosterCompareResult.ToAdd.filter((r) => !done[String(r.Name)]);
              }
              this.rosterAddSelection = [];
              this.rosterPage = 1;
              this.$nextTick(() => this.syncRosterTableSelection());
            } else {
              this.$message.error(res.data.msg || '配置失败');
            }
          }).catch(() => {
            this.rosterBatchLoading = false;
          });
        }).catch(() => { });
      });
    },
    /** 批量删除待删除列表中勾选的补贴用户。创建于 2026-09-16 */
    batchRemoveRosterUsers() {
      const rows = this.rosterRemoveSelection || [];
      if (!rows.length) {
        this.$message.warning('请勾选要删除的记录');
        return;
      }
      this.$confirm(`确认删除勾选的 ${rows.length} 条补贴用户吗？此操作不可自动恢复。`, '提示', { type: 'warning' }).then(() => {
        this.rosterRemoveLoading = true;
        const ids = rows.map((r) => r.Id).join(',');
        removeDiscountSubsidyUser({ ids }).then((res) => {
          this.rosterRemoveLoading = false;
          if (util.isEmt.format(res)) return;
          if (res.data.success) {
            this.$message.success('删除成功');
            const idSet = {};
            rows.forEach((r) => { idSet[String(r.Id)] = true; });
            if (this.rosterCompareResult && this.rosterCompareResult.ToRemove) {
              this.rosterCompareResult.ToRemove = this.rosterCompareResult.ToRemove.filter((r) => !idSet[String(r.Id)]);
            }
            this.rosterRemoveSelection = [];
            this.rosterPage = 1;
            this.$nextTick(() => this.syncRosterTableSelection());
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        }).catch(() => {
          this.rosterRemoveLoading = false;
        });
      }).catch(() => { });
    },
  },
  mounted() {
    const routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers) || [];
    if (!this.buttonList.some((b) => b.Func === 'handleRosterCompare')) {
      this.buttonList.push({
        name: '名单对比',
        Func: 'handleRosterCompare',
        type: 'warning',
        icon: 'el-icon-document-checked',
      });
    }
  },
};
</script>

<style scoped>
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.ps-pick-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}
.ps-layout {
  display: flex;
  gap: 0;
  height: 640px;
  max-height: calc(90vh - 140px);
  min-height: 420px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.ps-left {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e2e8f0;
  background: #fff;
  min-height: 0;
  overflow: hidden;
}
.ps-left-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex-shrink: 0;
}
.ps-left-header i { color: var(--btn-primary, #2563eb); }
.ps-scope-bar {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 0 12px 10px;
  flex-shrink: 0;
}
.ps-scope-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
}
.ps-scope-btn.is-active {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1d4ed8;
  font-weight: 600;
}
.ps-left-search { padding: 0 12px 10px; flex-shrink: 0; }
.ps-left-tree {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 8px 12px;
  position: relative;
  box-sizing: border-box;
}
.ps-left-tree >>> .el-tree-node__content { height: 34px; border-radius: 6px; }
.ps-left-tree >>> .el-tree-node.is-current > .el-tree-node__content { background: #dbeafe; }
.ps-tree-node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 24px);
  min-width: 0;
}
.ps-tree-node__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #94a3b8;
}
.ps-tree-node__dot.tone-school { background: var(--btn-primary, #2563eb); }
.ps-tree-node__dot.tone-campus { background: #f59e0b; }
.ps-tree-node__dot.tone-period { background: #8b5cf6; }
.ps-tree-node__dot.tone-grade { background: #06b6d4; }
.ps-tree-node__dot.tone-class { background: #64748b; }
.ps-tree-node__dot.tone-internal { background: #0ea5e9; }
.ps-tree-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
  font-size: 13px;
}
.ps-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
.ps-right {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 14px;
  overflow: hidden;
}
.ps-meta {
  margin-bottom: 10px;
  color: #475569;
  font-size: 13px;
  flex-shrink: 0;
}
.ps-meta-sep { margin: 0 6px; color: #cbd5e1; }
.ps-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-name-input { width: 180px; }
.ps-hint {
  font-size: 13px;
  color: #475569;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-hint-sub { color: #64748b; margin-left: 4px; }
.ps-hint--warn { color: #b45309; }
.ps-table-wrap {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  margin-bottom: 8px;
  overflow: hidden;
}
.ps-table-wrap >>> .el-table__body tr { cursor: pointer; }
.ps-avatar-empty { color: #c0c4cc; font-size: 12px; }
.ps-pager-wrap {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.ps-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

/* 左侧家校/内部切换。创建于 2026-09-16 */
.dp-left {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
/* 原生 button 必须能收缩，否则撑破 264 侧栏。最后更新：2026-10-30 */
.dept-scope-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 8px 10px 10px;
  border-bottom: 1px solid #f1f5f9;
  background: #f8fafc;
}
.dept-scope-btn {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  padding: 6px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.25;
  cursor: pointer;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: border-color .15s ease, color .15s ease, background .15s ease;
}
.dept-scope-btn:hover {
  border-color: #93c5fd;
  color: #2563eb;
}
.dept-scope-btn.is-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}
.dp-left >>> .department-pane {
  flex: 1;
  min-height: 0;
}

/* 自定义树节点用 .tree-node__label，长名称换行。最后更新：2026-10-30 */
.dp-left >>> .tree-node__label {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
  text-overflow: unset;
  overflow: visible;
}

.dp-left >>> .el-tree-node__content {
  height: auto;
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

/* 星期紧凑标签。创建于 2026-09-16 */
.week-chip-row {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
}
.week-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 4px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
.week-chip-empty {
  color: #cbd5e1;
}

/* 名册对比弹窗。最后更新：2026-09-16 */
.rc-dialog-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rc-dialog-title__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(145deg, #eff6ff, #dbeafe);
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.rc-dialog-title__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.25;
}
.rc-dialog-title__text strong {
  font-size: 16px;
  color: #0f172a;
  font-weight: 650;
}
.rc-dialog-title__text em {
  font-style: normal;
  font-size: 12px;
  color: #64748b;
  font-weight: 400;
}
.rc-dialog-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.rc-type-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.rc-type-bar__label {
  font-size: 13px;
  color: #475569;
  font-weight: 600;
  flex-shrink: 0;
}
.rc-type-bar__tip {
  font-size: 12px;
  color: #94a3b8;
}
.rc-rules {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 6px;
  flex-shrink: 0;
}
.rc-rule {
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
}
.rc-rule p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #475569;
  line-height: 1.35;
}
.rc-rule__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.02em;
}
.rc-rule--add {
  background: linear-gradient(180deg, #f0fdf4 0%, #fff 70%);
  border-color: #bbf7d0;
}
.rc-rule--add .rc-rule__badge {
  background: #dcfce7;
  color: #166534;
}
.rc-rule--del {
  background: linear-gradient(180deg, #fef2f2 0%, #fff 70%);
  border-color: #fecaca;
}
.rc-rule--del .rc-rule__badge {
  background: #fee2e2;
  color: #b91c1c;
}
.rc-rule--keep {
  background: linear-gradient(180deg, #eff6ff 0%, #fff 70%);
  border-color: #bfdbfe;
}
.rc-rule--keep .rc-rule__badge {
  background: #dbeafe;
  color: #1d4ed8;
}
.rc-rules-note {
  margin: 0 0 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
  flex-shrink: 0;
}
.rc-rules-note i { color: #f59e0b; }
.rc-result-panel {
  flex: 1 1 0;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.rc-result-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.rc-stat-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.rc-stat {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  min-width: 72px;
}
.rc-stat__label {
  font-size: 11px;
  color: #94a3b8;
}
.rc-stat__value {
  font-size: 14px;
  color: #0f172a;
  font-weight: 650;
  line-height: 1.2;
}
.rc-stat--add { background: #f0fdf4; border-color: #bbf7d0; }
.rc-stat--add .rc-stat__value { color: #16a34a; }
.rc-stat--del { background: #fef2f2; border-color: #fecaca; }
.rc-stat--del .rc-stat__value { color: #dc2626; }
.rc-stat--keep { background: #eff6ff; border-color: #bfdbfe; }
.rc-stat--keep .rc-stat__value { color: #2563eb; }
.rc-result-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.rc-file {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #64748b;
  font-size: 12px;
}
.rc-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  border-bottom: 1px solid #eef2f7;
  margin-bottom: 8px;
}
.rc-toolbar-right {
  flex-shrink: 0;
  padding-bottom: 8px;
  margin-left: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.rc-search {
  width: 220px;
}
.rc-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.rc-actions-tip {
  color: #94a3b8;
  font-size: 12px;
}
.rc-match-tip {
  margin-left: 6px;
  color: #64748b;
  font-size: 12px;
}
.rc-table-wrap {
  flex: 1 1 0;
  min-height: 120px;
  height: 0;
  overflow: hidden;
  position: relative;
}
.rc-pager {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 40px;
  padding: 10px 0 2px;
  background: #fff;
  position: relative;
  z-index: 2;
}
.rc-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 260px;
}
.rc-dropzone {
  width: 100%;
  max-width: 520px;
}
.rc-dropzone >>> .el-upload {
  width: 100%;
}
.rc-dropzone >>> .el-upload-dragger {
  width: 100%;
  height: auto;
  min-height: 200px;
  border-radius: 12px;
  border: 1.5px dashed #cbd5e1;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.rc-dropzone >>> .el-upload-dragger:hover {
  border-color: #60a5fa;
  background: linear-gradient(180deg, #eff6ff 0%, #fff 100%);
}
.rc-dropzone__inner {
  padding: 24px 20px;
  text-align: center;
}
.rc-dropzone__icon {
  font-size: 42px;
  color: #3b82f6;
  margin-bottom: 10px;
}
.rc-dropzone__inner h4 {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 650;
  color: #0f172a;
}
.rc-dropzone__inner p {
  margin: 0 0 10px;
  font-size: 13px;
  color: #64748b;
}
.rc-dropzone__inner p em {
  font-style: normal;
  color: #2563eb;
  font-weight: 600;
}
.rc-dropzone__fmt {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
}
.rc-tabs {
  flex: 1;
  min-width: 0;
}
.rc-tabs >>> .el-tabs__header {
  margin: 0;
}
.rc-tabs >>> .el-tabs__nav-wrap::after {
  display: none;
}
.rc-tabs >>> .el-tabs__content {
  display: none;
}
.rc-table {
  border-radius: 8px;
  overflow: hidden;
}
</style>

<style>
.roster-compare-dialog {
  margin-top: 2vh !important;
  max-height: 96vh;
  display: flex;
  flex-direction: column;
}
.roster-compare-dialog .el-dialog__header {
  padding: 14px 20px 10px;
  border-bottom: 1px solid #eef2f7;
  flex-shrink: 0;
}
.roster-compare-dialog .el-dialog__body {
  /* 固定高度，避免结果区 flex 被压成 0。最后更新：2026-09-16 */
  height: calc(96vh - 64px) !important;
  max-height: calc(96vh - 64px) !important;
  padding: 12px 16px 12px !important;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 0;
}
.roster-compare-dialog .el-dialog__headerbtn {
  top: 16px;
}
</style>
